// @ts-check

class WpOrder {
    /**
     * @param {HTMLElement} element
     * @param {string} className
     * @returns {HTMLElement|null}
     */
    _findParentByClass(element, className) {
        if (element.classList.contains(className)) return element;

        const parent = element.parentElement;
        if (!parent) return null;

        return this._findParentByClass(parent, className);
    }

    /**
     * @param {HTMLElement} element
     * @returns {HTMLInputElement}
     */
    _findNumberContainerInput(element) {
        const container = this._findParentByClass(element, "number-container");
        if (!container) {
            throw new Error("numberContainerPlus: number-container not found");
        }

        const input = container.querySelector(".quantity-input");
        if (!(input instanceof HTMLInputElement)) {
            throw new Error("numberContainerPlus: quantity-input not instance of HTMLInputElement");
        }

        return input;
    }

    /**
     * @param {HTMLElement} element
     */
    numberContainerPlus(element) {
        const input = this._findNumberContainerInput(element);

        const currentValue = parseInt(input.value);
        input.value = String(currentValue + 1);

        input.dispatchEvent(new Event("change"));
        input.dispatchEvent(new Event("keyup"));
    }

    /**
     * @param {HTMLElement} element
     */
    numberContainerMinus(element) {
        const input = this._findNumberContainerInput(element);

        const currentValue = parseInt(input.value);
        if (currentValue == 0) return;
        input.value = String(currentValue - 1);

        input.dispatchEvent(new Event("change"));
        input.dispatchEvent(new Event("keyup"));
    }

    /**
     * @param {Element|HTMLElement} container
     */
    productContainerEventListener(container) {
        container.querySelectorAll('.product-element').forEach((element) => {
            this._customProductCountValidation(element);

            // TODO: limit to elements
            element.addEventListener('click', () => {
                this._updateSubmitBtnPrice(container);
            });

            element.querySelectorAll('input').forEach((formElement) => {
                formElement.addEventListener('keyup', () => { this._updateSubmitBtnPrice(container); });
                formElement.addEventListener('blur', () => { this._updateSubmitBtnPrice(container); });
            });
        });

        this._updateSubmitBtnPrice(container);
    }

    /**
     * @param {Element|HTMLElement} container
     */
    _customProductCountValidation(container) {
        /** @type {HTMLInputElement|null} */
        const numberInput = container.querySelector('.product-quantity .number-container input.quantity-input');

        if (!numberInput) return;

        const min = parseInt(numberInput.getAttribute('data-min') ?? '0');

        let max = parseInt(numberInput.getAttribute('data-max') ?? '0');
        if (max === 0) max = 99999;

        /** @type {HTMLButtonElement|null} */
        const plusButton = container.querySelector('.product-quantity .plus-minus-container button.plus-button');

        /** @type {HTMLButtonElement|null} */
        const minusButton = container.querySelector('.product-quantity .plus-minus-container button.minus-button');

        const checkMinMax = () => {
            const value = parseInt(numberInput.value);

            const updateBasedOnMinMax = () => {
                if (value < min) numberInput.value = String(min);
                if (value > max) numberInput.value = String(max);
            };

            const setDisabledOnBtnIfMinMax = () => {
                if (plusButton) plusButton.removeAttribute('disabled');
                if (minusButton) minusButton.removeAttribute('disabled');

                if (value <= min) {
                    if (minusButton) minusButton.setAttribute('disabled', 'disabled');
                };
                if (value >= max) {
                    if (plusButton) plusButton.setAttribute('disabled', 'disabled');
                };
            };

            updateBasedOnMinMax();
            setDisabledOnBtnIfMinMax();
        };

        numberInput.addEventListener('change', () => { checkMinMax(); });
        checkMinMax();
    }

    /**
     * @param {Element|HTMLElement} container
     */
    _updateSubmitBtnPrice(container) {
        /** @type {number} (float) */
        let sum = 0;

        container.querySelectorAll('[data-product-price-number]')
            .forEach((element) => {
                const pricePerItem = element.getAttribute('data-product-price-number');

                /** @type {HTMLInputElement|null} */
                const input = element.querySelector('input.quantity-input');

                if (input && parseInt(input.value) > 0) {
                    sum += parseInt(input.value) * parseFloat(pricePerItem ?? '0');
                }
            });

        container.querySelectorAll('[data-product-price-checkbox]')
            .forEach((element) => {
                const pricePerItem = element.getAttribute('data-product-price-checkbox');

                /** @type {HTMLInputElement|null} */
                const checkbox = element.querySelector('input[type=checkbox]');

                if (checkbox && checkbox.checked) {
                    sum += parseFloat(pricePerItem ?? '0');
                }
            });

        container.querySelectorAll('[data-product-price-required]')
            .forEach((element) => {
                const pricePerItem = element.getAttribute('data-product-price-required');

                sum += parseFloat(pricePerItem ?? '0');
            });

        document.querySelectorAll('[data-price-target-inner]')
            .forEach((element) => {
                if (sum > 0) {
                    element.innerHTML = " für " + sum.toFixed(2) + " €";
                } else {
                    element.innerHTML = "";
                }
            });
    }

    /**
     * @param {Element|HTMLElement} container
     */
    _updateSubmitBtnPriceOverview(container) {
        /** @type {number} (float) */
        let sum = 0;

        container.querySelectorAll('[data-product-price-number]')
            .forEach((element) => {
                const pricePerItem = element.getAttribute('data-product-price-number');

                const quantity = element.getAttribute('data-product-quantity');

                sum += parseFloat(quantity ?? '0') * parseFloat(pricePerItem ?? '0');
            });
        document.querySelectorAll('[data-price-target-inner]')
            .forEach((element) => {
                if (sum > 0) {
                    element.innerHTML = " für " + sum.toFixed(2) + " €";
                } else {
                    element.innerHTML = "";
                }
            });
    }
}
globalThis.WpOrderUtils = new WpOrder();

window.addEventListener("load", () => {
    document.querySelectorAll(".tx-wp-order").forEach((element) => {
        if (element.querySelectorAll('form').length === 0) return;

        WpOrderUtils.productContainerEventListener(element);
        WpFormHandler.initOnContainer(element);

        element.querySelectorAll('.quantity-input').forEach((element) => {
            if (!(element instanceof HTMLInputElement)) return console.error("WpOrder: quantity-input not instance of HTMLInputElement");
            WpFormHandler.validateNumericTextInputEvListener(element);
        });
    });
    document.querySelectorAll('.order-form-wrapper-overview').forEach((element) => {
        WpOrderUtils._updateSubmitBtnPriceOverview(element);
    });
});